module.exports = __webpack_public_path__ + "img/dn-logo-tagline.0e105c42.png";